import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Order } from '../Models/order'
import { OrderService } from '../Services/order'

@Component({
  selector: 'order',
  templateUrl: '../Templates/order.html',
})

export class OrderComponent {

  id: string;
  order: Order;
  error: boolean;

  constructor(
    private route: ActivatedRoute,
    private orderService: OrderService,
  ) {}

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.id = params['id'];
      this.loadOrder();
    });
  }

  redirectToPaymentUrl(): void {
    if (this.order.payment_redirect_url) {
      location.href = this.order.payment_redirect_url;
    }
  }

  loadOrder(): void {
    // retrieve status from backend

    this.order = null;
    this.error = false;

    this.orderService.get(this.id).subscribe(
      data => {
        this.order = new Order()
        this.order.setData(data);
      },
      error => {
        this.error = true;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Components/order.ts